import { IMetricInfo } from '../models/IMetricInfo';
import { MapperHelper } from './MapperHelper';

export module MetricMapper {

  export function map(responseList: Array<any>): IMetricInfo[]  {
    const metricList: IMetricInfo[] = [];

    for(let item of responseList){
      metricList.push(mapOne(item));
    }

    return metricList;
  }

  export function mapOne(item: any) : IMetricInfo{
    return {
      id: item.content.metricId,
      name: item.content.title,
      luid: item.content.luid,
      parsedData: item.content.parsedData,
      metricChanged: null,
      contentType: item.content.type,
      viewId: item.content.viewId,
      metricConnectedViewName: item.content.viewName,
      metricUpdated: null,
      updatedAt: MapperHelper.toDate(item.content.lastModified),
      favorite: false,
      owner: {
        id: item.content.ownerId,
        displayName: item.content.ownerName,
        username: item.content.ownerUserName
      }
    };
  }
}
